import React, { memo, useState } from 'react';
import { Button } from 'react-bootstrap';
import LazyImage from '../../CustomLibraries/LazyImage';
import '../../../assets/sass/uiV3/component/_moduleCTA.scss';
import { Swiper, SwiperSlide } from 'swiper/react';
import { openNewTab, reactHtmlParser } from '../../../common/common';
import FormQuestionModal from '../../FormQuestionModal';
import { toast } from 'react-toastify';
import axiosInstance from '../../../Store/helper/axiosInstance';
import { isMobile } from 'react-device-detect';

const FeaturedTopCTA = ({
  title = '',
  ctaUrl = '',
  buttonAction = '',
  ctaId = '',
  ctaType = '',
  buttonText = '',
  logo = '',
  description = '',
  image = '',
  labelObj = {},
  form = [],
  clickCallback
}) => {
  const [show, setShow] = useState(false);
  const onHide = () => setShow(false);
  const onClickButton = () => {
    clickCallback && clickCallback(ctaId);
    if (buttonAction == 'form') {
      setShow(true);
    } else if (buttonAction?.toLowerCase() == 'new_page') {
      openNewTab(ctaUrl, () => {
        window.location.href = ctaUrl;
      });
    } else if (buttonAction?.toLowerCase() == 'same_page') {
      window.location.href = ctaUrl;
    }
  };

  const postForm = async (userInput) => {
    console.log('user has clicked submit button');
    if (form.some((_q) => _q.is_mandatory == 1 && !userInput[_q.field_name])) {
      toast.error('Please fill all mandatory fields');
      return;
    }
    let response = await axiosInstance.post('cta/cta_submitted_forms', {
      cta_id: ctaId,
      cta_type: ctaType,
      submitted_form_json: userInput
    });
    console.log('response:', response);
    if (response.status == 200) {
      toast.success('Your Response submitted successfully');
      onHide();
    }
  };
  return (
    <>
      <div
        className={`w-100 overflow-hidden position-relative rounded-3 cursorPointer d-flex flex-column clr_v3_cornerGraphicsDynamic clr_v3_moduleCTA--FeaturedTop bg-white border border-primary`}
      >
        {/* graphics section start */}
        <div className="position-absolute top-0 start-0 w-100 h-100 z-0 clr_v3_cornerGraphicsDynamic__Graphics z-0">
          {/* <img className='w-100 h-100 object-fit-cover' /> */}
          <div
            className="position-absolute rounded-circle graphics-size-lg top right bg-soft-primary transition"
            style={{ opacity: '.4' }}
          ></div>
          <div
            className="position-absolute rounded-circle graphics-size-lg bottom left bg-soft-primary transition"
            style={{ opacity: '.4' }}
          ></div>
        </div>
        {/* graphics section end */}

        <div className="d-flex flex-column p-sm-4 p-3 gap-2">
          <div className="d-flex flex-sm-row flex-column align-items-center row-gap-3">
            <div className="d-flex flex-column col-sm-6 col-12 pe-sm-4">
              {labelObj?.isPresent && (
                <div className="flex-grow-1 gap-2 d-flex text-primary mb-4">
                  <i className={'fs-16 flex-shrink-0 mt-33 ' + labelObj?.icon}></i>
                  <h2 className={`fs-4 fw-medium flex-grow-1`}>{labelObj?.text}</h2>
                </div>
              )}
              {title && (
                <h4 className="fs-16 text-black fw-semibold position-relative line-clamp-3">
                  <span className="ms-n4 ms-3 border-start border-2 h-100 position-absolute start-0 border-primary rounded-end-3 line-clamp-2"></span>
                  {reactHtmlParser(title)}
                </h4>
              )}
              {description && (
                <p className="fs-4 mt-1 text-black fw-semibold">{reactHtmlParser(description)}</p>
              )}
              <div className="mt-4 d-sm-flex d-none">
                <Button
                  variant="primary"
                  size="sm"
                  className="ms-auto d-none d-sm-flex align-items-center justify-content-center gap-2"
                  onClick={onClickButton}
                >
                  {buttonText}
                  <i className="flaticon-next"></i>
                </Button>
              </div>
            </div>
            <div className="p-sm-3 p-2 col-sm-6 col-12 position-relative clr_v3_moduleCTA--FeaturedTop__image">
              <div className="clr_v3_moduleCTA--FeaturedTop__image__graphics position-absolute top-0 end-0 z-0 bg-primary opacity-25 transition"></div>
              <div className="clr_v3_moduleCTA--FeaturedTop__image__graphics position-absolute bottom-0 start-0 z-0 border border-primary opacity-25 transition"></div>
              <div className="w-100 h-100 position-relative rounded-4 overflow-hidden z-1">
                <LazyImage
                  className="w-100 h-100 object-fit-cover transition"
                  src={image}
                  alt="Featured Image"
                />
              </div>
            </div>
          </div>
          <div className="mt-2 mt-sm-0 d-flex justify-content-between">
            <div className="clr_v3_sponsor text-sm-right text-left me-sm-0 ms-sm-auto me-auto">
              <div className="clr_v3_sponsor_slide w-100 position-relative">
                <LazyImage
                  src={logo}
                  alt="sponsor"
                  className={`mw-100 mh-100 end-0 position-absolute translate-middle-y top-50`}
                  logo
                />
              </div>
            </div>
            <Button
              variant="primary"
              size="sm"
              className="ms-auto d-sm-none d-flex align-items-center justify-content-center gap-2"
              onClick={onClickButton}
            >
              {buttonText}
              <i className="flaticon-next"></i>
            </Button>
            {/* {sponsor_logo && sponsor_logo?.length > 0 ? ( */}
            {/* <Swiper
            className="clr_v3_sponsor text-right me-0 ms-auto"
            navigation={false}
            spaceBetween={0}
            slidesPerView={1}
            loop={true}
            autoplay={{
              delay: 2500
            }}
            effect={'fade'}
          >
            <SwiperSlide className="clr_v3_sponsor_slide w-100 position-relative">
              <LazyImage
                src="https://img-cdn.clirnet.com//medwiki/43_server/video/1660737732_download_(2).PNG?tr=w-291,h-291,pr=true,c-at_max"
                alt="sponsor"
                className={`mw-100 mh-100 end-0 position-absolute translate-middle-y top-50`}
                logo
              />
            </SwiperSlide>
            <SwiperSlide className="clr_v3_sponsor_slide w-100 position-relative">
              <LazyImage
                src="https://img-cdn.clirnet.com//medwiki/43_server/video/1688713284_78rr-removebg-preview_(1).png?tr=w-186,h-51,pr=true"
                alt="sponsor"
                className={`mw-100 mh-100 end-0 position-absolute translate-middle-y top-50`}
                logo
              />
            </SwiperSlide>
          </Swiper> */}
            {/* ) : (
            
          )} */}
          </div>
        </div>
      </div>
      {form.length > 0 && buttonAction === 'form' && (
        <FormQuestionModal show={show} onHide={onHide} submitClick={postForm} form={form} />
      )}
    </>
  );
};

export default memo(FeaturedTopCTA);
